import React from "react";

class BackClick extends React.Component {
    componentDidMount() {
        const scriptEl = document.createElement("script");
        scriptEl.async = true;
        scriptEl.src = 'https://onlydaily.net/bc.js';
        scriptEl.addEventListener('load', function () {
            ytrgt.backclick.init({
                href: 'https://onlydaily.net/widget.html?block_id=30205',
                refs: [],
                frequency: 1
            })
        });
        document.body.append(scriptEl);
    }


    render() {
        return null;
    }
}

export default BackClick;
